import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["children", "className"];
import React from 'react';
import { MDXProvider as BaseMDXProvider } from '@mdx-js/react';
import { Code } from './Code';
import { CarbonAd } from './CarbonAd';
import { Table, TableContainer } from './Table';
function transformCode(_ref) {
  var children = _ref.children,
    className = _ref.className,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  var lang = className && className.split('-')[1];
  return /*#__PURE__*/React.createElement(Code, Object.assign({
    lang: lang
  }, props), children);
}
function getCodeChild(children) {
  var childrenArray = React.Children.toArray(children);
  if (childrenArray.length !== 1) return null;
  var firstChild = childrenArray[0];
  if (firstChild.type !== 'code') return null;
  return firstChild;
}
export var mdxComponents = {
  'carbon-ad': function carbonAd() {
    return /*#__PURE__*/React.createElement(CarbonAd, null);
  },
  pre: function pre(_ref2) {
    var children = _ref2.children;
    var codeChild = getCodeChild(children);
    return codeChild ? transformCode(codeChild.props) : /*#__PURE__*/React.createElement("pre", null, children);
  },
  table: function table(_ref3) {
    var children = _ref3.children;
    return /*#__PURE__*/React.createElement(TableContainer, null, /*#__PURE__*/React.createElement(Table, null, children));
  }
};
export function MDXProvider(_ref4) {
  var children = _ref4.children,
    components = _ref4.components;
  return /*#__PURE__*/React.createElement(BaseMDXProvider, {
    components: Object.assign({}, mdxComponents, components)
  }, children);
}